/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  SubmitTraceabilityRequestsMutationRequest,
  SubmitTraceabilityRequestsMutationResponse,
} from "../types/SubmitTraceabilityRequests.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const submitTraceabilityRequestsMutationKey = () =>
  [{ url: "/v1/traceability-requests/submit" }] as const

export type SubmitTraceabilityRequestsMutationKey = ReturnType<
  typeof submitTraceabilityRequestsMutationKey
>

/**
 * @summary Submit traceability requests (direct, grouped, on-behalf)
 * {@link /v1/traceability-requests/submit}
 */
export async function submitTraceabilityRequests(
  data: SubmitTraceabilityRequestsMutationRequest,
  config: Partial<RequestConfig<SubmitTraceabilityRequestsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SubmitTraceabilityRequestsMutationResponse,
    ResponseErrorConfig<Error>,
    SubmitTraceabilityRequestsMutationRequest
  >({
    method: "POST",
    url: `/v1/traceability-requests/submit`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function submitTraceabilityRequestsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<SubmitTraceabilityRequestsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = submitTraceabilityRequestsMutationKey()
  return mutationOptions<
    ResponseConfig<SubmitTraceabilityRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: SubmitTraceabilityRequestsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return submitTraceabilityRequests(data, config)
    },
  })
}

/**
 * @summary Submit traceability requests (direct, grouped, on-behalf)
 * {@link /v1/traceability-requests/submit}
 */
export function useSubmitTraceabilityRequests<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<SubmitTraceabilityRequestsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: SubmitTraceabilityRequestsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<SubmitTraceabilityRequestsMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? submitTraceabilityRequestsMutationKey()

  const baseOptions = submitTraceabilityRequestsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<SubmitTraceabilityRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: SubmitTraceabilityRequestsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<SubmitTraceabilityRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: SubmitTraceabilityRequestsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<SubmitTraceabilityRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: SubmitTraceabilityRequestsMutationRequest },
    TContext
  >
}
